import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Artwork} from "../../models/artwork";
import {ArtworkService} from "../../services/artwork/artwork.service";
import {MessagesService} from "../../services/messages/messages.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-artwork-modal',
    templateUrl: './artwork-modal.component.html',
    styleUrls: ['./artwork-modal.component.scss']
})
export class ArtworkModal implements OnInit {

    @Input() projectId: String;
    @Input() databaseId: String;
    @Input() artwork: Artwork;

    artworkForm: FormGroup;
    artworkFormIsSubmitted: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private artworkService: ArtworkService,
        private messagesService: MessagesService,
    ) {
    }

    ngOnInit() {
        this.artworkForm = this.formBuilder.group({
            name: [this.artwork ? this.artwork.name || '' : ''],
        });
    }

    submitArtworkForm() {
        this.artworkFormIsSubmitted = true;

        if (this.artworkForm.invalid) return;

        this.artworkService.postArtwork(this.projectId, this.databaseId, this.artworkForm.controls.name.value)
            .subscribe(
                () => {
                  this.messagesService.successToast('Artwork created.');
                },
              err => this.messagesService.errorToast(err),
                () => this.activeModal.close(true)
            );
    }
}
